const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

document.addEventListener('DOMContentLoaded', () => {
  const summaries = document.querySelectorAll('summary[role="button"]');

  summaries.forEach(summary => {
    summary.addEventListener('click', (event) => {
      event.preventDefault();

      const detailsElement = summary.closest('details');
      const contentId = summary.getAttribute('aria-controls');
      const contentElement = document.getElementById(contentId);

      if (!detailsElement || !contentElement) {
        console.warn('Không tìm thấy phần tử <details> hoặc phần tử nội dung được kiểm soát.');
        return;
      }

      const isOpen = detailsElement.hasAttribute('open');

      if (isOpen) {
        // Đóng thẻ:
        detailsElement.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        contentElement.style.display = 'none'; // Hoặc xóa class điều khiển hiển thị
        // Có thể cuộn lên đầu summary nếu muốn khi đóng, nhưng thường không cần thiết
      } else {
        // Mở thẻ:
        detailsElement.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        contentElement.style.display = 'block'; // Hoặc thêm class điều khiển hiển thị

        // --- Bắt đầu thêm logic cuộn mượt mà ---
        // Đảm bảo contentElement được hiển thị (display: block) trước khi cuộn
        // Nếu bạn dùng transition hoặc animation, bạn có thể cần đợi một chút
        // để nội dung có chiều cao thực tế trước khi cuộn.
        // Trong trường hợp này, vì bạn đã đặt display: block, nó sẽ có chiều cao ngay lập tức.
        // detailsElement.scrollIntoView({
        //   behavior: 'smooth', // Kích hoạt cuộn mượt mà
        //   block: 'start'     // Cuộn để phần tử nằm ở đầu (hoặc gần đầu) của khung nhìn
        // });
        // --- Kết thúc logic cuộn mượt mà ---
      }

      // Cập nhật biểu tượng mũi tên (ví dụ: xoay SVG)
      const caretIcon = summary.querySelector('.icon-caret');
      if (caretIcon) {
        if (isOpen) {
          caretIcon.style.transform = 'rotate(0deg)'; // Trở lại trạng thái ban đầu
        } else {
          caretIcon.style.transform = 'rotate(180deg)'; // Xoay 180 độ
        }
        caretIcon.style.transition = 'transform 0.3s ease-in-out';
      }
    });
  });
});



// document.addEventListener('DOMContentLoaded', () => {
//   // Tìm tất cả các tiêu đề accordion trong khu vực sản phẩm
//   const summaries = document.querySelectorAll('.product__accordion details > summary');

//   summaries.forEach(summary => {
//     summary.addEventListener('click', (event) => {
      
//       // 1. Lấy vị trí cuộn hiện tại *ngay khi* click
//       const scrollY = window.scrollY;

//       // 2. Yêu cầu trình duyệt chạy code này ngay trước lần "vẽ" tiếp theo.
//       // Việc này đảm bảo <details> đã mở ra, và JS của theme (nếu có)
//       // đã kịp chạy và "phá" vị trí cuộn.
//       requestAnimationFrame(() => {
//         // 3. Ép trình duyệt cuộn trở lại đúng vị trí cũ.
//         window.scrollTo(0, scrollY);
//       });
//     });
//   });
// });